var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*eslint no-useless-escape: 0*/
import React, { useState, useEffect } from 'react';
import { Box, Button, IconButton, Typography, MenuItem, Grid, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import { MODOS, MENSAGENS, getDataFormatada, validarData, verificarDatas, parseDate, getCodigoOfertaFormatada } from '../../../utils';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { BoxPrincipal, BoxBotoes } from '../../../components/form_box';
import Loading from '../../../components/loading';
import { useNavigate, useParams } from 'react-router-dom';
import { BotaoFechar, BotaoAuxiliar } from '../../../components/botoes';
import { InputDados } from '../../../components/input_dados';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import GridComp from '../../../components/grid';
import { getReeducandosOferta, getOferta, STATUS_API, cadastrarAgendamento, cadastrarEncaminhamento, cadastrarDesistencia, finalizarAtendimento, reiniciarAtendimento, gerarTermoCompromisso, gerarTermoEncaminhamento, } from './atendimentos.service';
import { CalendarToday, Replay, ThumbDown, Work, Print, AssignmentInd as AssignmentIndIcon } from '@mui/icons-material';
export var AtendimentosEditar = function () {
    var _a, _b;
    var navigate = useNavigate();
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(true), LoadingInicio = _d[0], setLoadingInicio = _d[1];
    var _e = useParams(), id = _e.id, modo = _e.modo;
    var _f = useState({}), Oferta = _f[0], setOferta = _f[1];
    var _g = useState([]), ReeducandosOferta = _g[0], setReeducandosOferta = _g[1];
    var _h = useState(), ReeducandoSelecionado = _h[0], setReeducandoSelecionado = _h[1];
    var _j = useState(false), PopupAgendamentoAberto = _j[0], setPopupAgendamentoAberto = _j[1];
    var _k = useState(false), PopupEncaminhamentoAberto = _k[0], setPopupEncaminhamentoAberto = _k[1];
    var _l = useState(false), PopupDesistenciaAberto = _l[0], setPopupDesistenciaAberto = _l[1];
    var _m = useState(false), PopupFinalizacaoAberto = _m[0], setPopupFinalizacaoAberto = _m[1];
    var _o = useState(false), ErroEmissaoTermoAberto = _o[0], setErroEmissaoTermoAberto = _o[1];
    var _p = useState(''), Data = _p[0], setData = _p[1];
    var _q = useState(''), Observacao = _q[0], setObservacao = _q[1];
    var _r = useState(), AgendamentoExameAdimissional = _r[0], setAgendamentoExameAdimissional = _r[1];
    var _s = useState(null), AgendamentoArquivoSelecionado = _s[0], setAgendamentoArquivoSelecionado = _s[1];
    var _t = useState(''), AgendamentoNomeArquivoOriginal = _t[0], setAgendamentoNomeArquivoOriginal = _t[1];
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, Oferta_1, Reeducandos;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!id) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all([getOferta(id), getReeducandosOferta(id)])];
                case 1:
                    _a = _b.sent(), Oferta_1 = _a[0], Reeducandos = _a[1];
                    if (Reeducandos.Status == STATUS_API.ERRO) {
                        alert(Reeducandos.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        setReeducandosOferta(Reeducandos);
                    }
                    if (Oferta_1.Status == STATUS_API.ERRO) {
                        alert(Oferta_1.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        setOferta(Oferta_1);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    alert('ID da Oferta não informada');
                    _b.label = 3;
                case 3:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var COLUNAS = [
        {
            field: 'candidato',
            headerName: 'Candidato',
            width: 250,
            valueGetter: function (_value, row) { var _a; return (_a = row.reeducando) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'vaga',
            headerName: 'Vaga',
            width: 150,
            valueGetter: function (_value, row) { var _a; return (_a = row === null || row === void 0 ? void 0 : row.vaga) === null || _a === void 0 ? void 0 : _a.descricao; },
        },
        {
            field: 'perfil_laboral_id',
            headerName: 'Perfil',
            width: 150,
            valueGetter: function (_value, row) { var _a, _b; return (_b = (_a = row.vaga) === null || _a === void 0 ? void 0 : _a.perfil_laboral) === null || _b === void 0 ? void 0 : _b.nome; },
        },
        {
            field: 'jornada_trabalho_id',
            headerName: 'Jornada',
            width: 150,
            valueGetter: function (_value, row) { var _a, _b; return (_b = (_a = row.vaga) === null || _a === void 0 ? void 0 : _a.jornada_trabalho) === null || _b === void 0 ? void 0 : _b.nome; },
        },
        {
            field: 'contato',
            headerName: 'Contato',
            width: 150,
            valueGetter: function (_value, row) { var _a, _b; return (_b = (_a = row.reeducando) === null || _a === void 0 ? void 0 : _a.contatos[0]) === null || _b === void 0 ? void 0 : _b.contato; },
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 200,
            renderCell: function (params) {
                var color = '';
                // Defina as cores com base no valor do status
                switch (params.value) {
                    case 'ENCAMINHADO':
                        color = 'orange';
                        break;
                    case 'FINALIZADO':
                        color = 'green';
                        break;
                    case 'DESISTENCIA':
                        color = 'red';
                        break;
                    case 'AGENDADO':
                        color = 'black';
                        break;
                    default:
                        color = 'grey';
                }
                return (_jsx(Typography, __assign({ mt: 0.5, style: { color: color } }, { children: params.value })));
            },
        },
        {
            field: 'data',
            headerName: 'Data Alteração',
            description: 'Data da última alteração',
            width: 250,
            valueGetter: function (_value, row) { return (row.updated_at ? getDataFormatada(row.updated_at) : getDataFormatada(row.created_at)); },
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 120,
            renderCell: function (params) { return (_jsxs(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end' }, { children: [_jsx(Tooltip, __assign({ title: 'Visualizar Vaga', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'terceary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 1, marginTop: -1 }, onClick: function () { return navigate("".concat(ROUTES.ATENDIMENTO_VISUALIZAR_VAGA, "/").concat(params.row.vaga_id, "/").concat(MODOS.VISUALIZAR)); } }, { children: _jsx(AssignmentIndIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) })), params.row.status == 'EM ATENDIMENTO' && (_jsx(Tooltip, __assign({ title: 'Agendamento', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'black', style: { width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 1, marginTop: -1 }, onClick: function () {
                                    setReeducandoSelecionado(params.row);
                                    setPopupAgendamentoAberto(true);
                                } }, { children: _jsx(CalendarToday, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) }))), params.row.status == 'AGENDADO' && (_jsx(Tooltip, __assign({ title: 'Encaminhamento', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'secondary.main', style: { width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () {
                                    setReeducandoSelecionado(params.row);
                                    setPopupEncaminhamentoAberto(true);
                                } }, { children: _jsx(ArrowForwardIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) }))), params.row.status != 'FINALIZADO' && params.row.status != 'DESISTENCIA' && (_jsx(Tooltip, __assign({ title: 'Desist\u00EAncia', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'error.main', style: { width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () {
                                    setReeducandoSelecionado(params.row);
                                    setPopupDesistenciaAberto(true);
                                } }, { children: _jsx(ThumbDown, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) }))), params.row.status == 'ENCAMINHADO' && (_jsx(Tooltip, __assign({ title: 'Finaliza\u00E7\u00E3o', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'green', style: { width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () {
                                    setReeducandoSelecionado(params.row);
                                    setPopupFinalizacaoAberto(true);
                                } }, { children: _jsx(Work, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) }))), params.row.status == 'FINALIZADO' && (_jsx(Tooltip, __assign({ title: 'Emiss\u00E3o de Termo', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'purple', style: { width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                setReeducandoSelecionado(params.row);
                                                return [4 /*yield*/, emitirTermoCompromisso(params.row.id)];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); } }, { children: _jsx(Print, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) }))), params.row.status == 'ENCAMINHADO' && params.row.status == 'AGENDADO' && (_jsx(Tooltip, __assign({ title: 'Voltar Status', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'grey', style: { width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ color: 'primary', style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () {
                                    setReeducandoSelecionado(params.row);
                                    voltarStatusAnterior(params.row.id);
                                } }, { children: _jsx(Replay, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) })))] }))); },
        },
    ];
    var finalizarAlteracao = function () {
        setPopupAgendamentoAberto(false);
        setPopupDesistenciaAberto(false);
        setPopupEncaminhamentoAberto(false);
        setPopupFinalizacaoAberto(false);
        setData('');
        setObservacao('');
    };
    var handleClose = function () {
        if (confirm('Tem certeza que deseja sair?')) {
            finalizarAlteracao();
        }
    };
    var emitirTermoCompromisso = function (AtendimentoID) { return __awaiter(void 0, void 0, void 0, function () {
        var novaAba, TermoURL, link, error_1, httpStatus;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    novaAba = window.open('about:blank', '_blank');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, gerarTermoCompromisso(AtendimentoID.toString())];
                case 2:
                    TermoURL = _a.sent();
                    if (!TermoURL)
                        throw new Error('PDF não recebido');
                    if (novaAba) {
                        novaAba.opener = null;
                        novaAba.location.href = TermoURL;
                    }
                    else {
                        link = document.createElement('a');
                        link.href = TermoURL;
                        link.download = "termo_compromisso_".concat(AtendimentoID, ".pdf");
                        link.click();
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    novaAba === null || novaAba === void 0 ? void 0 : novaAba.close();
                    httpStatus = error_1 === null || error_1 === void 0 ? void 0 : error_1.httpStatus;
                    if (httpStatus === 401) {
                        navigate(ROUTES.LOGOUT);
                    }
                    else if (httpStatus === 403) {
                        navigate(ROUTES.SEM_PERMISSAO);
                    }
                    else {
                        setErroEmissaoTermoAberto(true);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var emitirTermoEncaminhamento = function (AtendimentoID) { return __awaiter(void 0, void 0, void 0, function () {
        var TermoURL, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, gerarTermoEncaminhamento(AtendimentoID.toString())];
                case 1:
                    TermoURL = _a.sent();
                    if (TermoURL) {
                        try {
                            link = document.createElement('a');
                            link.href = TermoURL;
                            link.download = "termo_encaminhamento_".concat(AtendimentoID, ".pdf");
                            // Adiciona o link ao documento e dispara o download
                            document.body.appendChild(link);
                            link.click();
                            // Remove o link do documento
                            document.body.removeChild(link);
                            // Libera a URL temporária
                            window.URL.revokeObjectURL(TermoURL);
                        }
                        catch (error) {
                            console.log('error : ' + error);
                        }
                    }
                    else {
                        alert('Erro ao gerar o termo');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var voltarStatusAnterior = function (AtendimentoID) { return __awaiter(void 0, void 0, void 0, function () {
        var Resposta;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm('Tem certeza que deseja voltar o status do atendimento?')) {
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    return [4 /*yield*/, reiniciarAtendimento(AtendimentoID.toString())];
                case 1:
                    Resposta = _a.sent();
                    //console.log('Resp', JSON.stringify(Resp));
                    if (Resposta.Status == STATUS_API.ERRO) {
                        alert(Resposta.Mensagem);
                    }
                    else {
                        alert('Atendimento reinicializado com sucesso');
                        finalizarAlteracao();
                        carregarDados();
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleFileChange = function (event) {
        var _a, _b;
        if (!((_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0]))
            return;
        var file = event.target.files[0];
        var fileName = file.name;
        var fileExtension = (_b = fileName.split('.').pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        if (fileExtension !== 'pdf') {
            alert('Selecione um arquivo do tipo PDF');
            event.target.value = '';
            return;
        }
        setAgendamentoArquivoSelecionado(file);
        setAgendamentoNomeArquivoOriginal(fileName);
    };
    var validarDados = function () {
        if (!Data) {
            alert('Informe a Data do agendamento');
            return false;
        }
        if (!validarData(Data)) {
            alert('Data do agendamento é inválida');
            return false;
        }
        var DataHoraAtual = new Date();
        if (!verificarDatas(DataHoraAtual.toLocaleDateString(), Data, true)) {
            alert("Data ".concat(MENSAGENS.DATA_MENOR_DATA_ATUAL));
        }
        if (!Observacao) {
            alert('Informe a Observação');
            return false;
        }
        return true;
    };
    var salvarAgendamento = function () { return __awaiter(void 0, void 0, void 0, function () {
        var FormDataAux, Resposta;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    FormDataAux = new FormData();
                    if (AgendamentoArquivoSelecionado) {
                        FormDataAux.append('agendamento_nome_arquivo', AgendamentoArquivoSelecionado.name);
                        FormDataAux.append('arquivo', AgendamentoArquivoSelecionado);
                    }
                    FormDataAux.append('agendamento_data', Data);
                    FormDataAux.append('agendamento_observacao', Observacao);
                    FormDataAux.append('agendamento_exame_adicional', AgendamentoExameAdimissional ? 'true' : 'false');
                    return [4 /*yield*/, cadastrarAgendamento(FormDataAux, (_a = ReeducandoSelecionado === null || ReeducandoSelecionado === void 0 ? void 0 : ReeducandoSelecionado.id) !== null && _a !== void 0 ? _a : '')];
                case 1:
                    Resposta = _b.sent();
                    if (Resposta.Status == STATUS_API.ERRO) {
                        alert(Resposta.Mensagem);
                    }
                    else {
                        alert('Agendamento cadastrado com sucesso');
                        setAgendamentoArquivoSelecionado(null);
                        setAgendamentoNomeArquivoOriginal('');
                        finalizarAlteracao();
                        carregarDados();
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var salvarEncaminhamento = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resposta;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    Dados = {
                        encaminhamento_data: parseDate(Data),
                        encaminhamento_observacao: Observacao,
                    };
                    return [4 /*yield*/, cadastrarEncaminhamento(Dados, (_a = ReeducandoSelecionado === null || ReeducandoSelecionado === void 0 ? void 0 : ReeducandoSelecionado.id) !== null && _a !== void 0 ? _a : '')];
                case 1:
                    Resposta = _c.sent();
                    if (!(Resposta.Status == STATUS_API.ERRO)) return [3 /*break*/, 2];
                    alert(Resposta.Mensagem);
                    return [3 /*break*/, 4];
                case 2:
                    alert('Encaminhamento cadastrado com sucesso');
                    finalizarAlteracao();
                    carregarDados();
                    return [4 /*yield*/, emitirTermoEncaminhamento((_b = ReeducandoSelecionado === null || ReeducandoSelecionado === void 0 ? void 0 : ReeducandoSelecionado.id) !== null && _b !== void 0 ? _b : 0)];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var salvarDesistencia = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resposta;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    Dados = {
                        desistencia_data: parseDate(Data),
                        desistencia_observacao: Observacao,
                    };
                    return [4 /*yield*/, cadastrarDesistencia(Dados, (_a = ReeducandoSelecionado === null || ReeducandoSelecionado === void 0 ? void 0 : ReeducandoSelecionado.id) !== null && _a !== void 0 ? _a : '')];
                case 1:
                    Resposta = _b.sent();
                    if (Resposta.Status == STATUS_API.ERRO) {
                        alert(Resposta.Mensagem);
                    }
                    else {
                        alert('Desistência cadastrada com sucesso');
                        finalizarAlteracao();
                        carregarDados();
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var salvarFinalizarAtendimento = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resposta;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    Dados = {
                        finalizacao_data: parseDate(Data),
                        finalizacao_observacao: Observacao,
                    };
                    return [4 /*yield*/, finalizarAtendimento(Dados, (_a = ReeducandoSelecionado === null || ReeducandoSelecionado === void 0 ? void 0 : ReeducandoSelecionado.id) !== null && _a !== void 0 ? _a : '')];
                case 1:
                    Resposta = _b.sent();
                    if (Resposta.Status == STATUS_API.ERRO) {
                        alert(Resposta.Mensagem);
                    }
                    else {
                        alert('Atendimento finalizado com sucesso');
                        finalizarAlteracao();
                        carregarDados();
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(ContainerPainel, __assign({ modo: modo, pagina_acima: PAGINAS.ATENDIMENTOS, pagina_especifica_permissao: FUNCIONALIDADES.ATENDIMENTOS, link_pagina_acima: ROUTES.ATENDIMENTOS }, { children: _jsx(BoxPrincipal, __assign({ sx: { width: '100%', mt: -3 } }, { children: !LoadingInicio && (_jsxs(_Fragment, { children: [_jsxs(Box, { children: [_jsx(Typography, { variant: 'h6', gutterBottom: true }), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 1.5 }, { children: _jsx(InputDados, { id: 'codigo-oferta', label: 'C\u00F3digo da Oferta', value: getCodigoOfertaFormatada(id), disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'descricao', label: 'Descri\u00E7\u00E3o', value: Oferta === null || Oferta === void 0 ? void 0 : Oferta.descricao, variant: 'outlined', size: 'small', disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'instituicao', label: 'Institui\u00E7\u00E3o', value: (_b = (_a = Oferta === null || Oferta === void 0 ? void 0 : Oferta.instituicao) === null || _a === void 0 ? void 0 : _a.dados) === null || _b === void 0 ? void 0 : _b.razao_social, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'n_termo_contrato', label: 'N\u00BA Termo Contrato', value: Oferta === null || Oferta === void 0 ? void 0 : Oferta.n_termo_contrato, variant: 'outlined', size: 'small', disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2.5 }, { children: _jsx(InputDados, { id: 'situacao_oferta', label: 'Situa\u00E7\u00E3o da Oferta', value: Oferta === null || Oferta === void 0 ? void 0 : Oferta.situacao_oferta, variant: 'outlined', size: 'small', fullWidth: true, disabled: true }) }))] })), _jsx(Box, __assign({ mt: 8 }, { children: _jsx(GridComp, { rows: ReeducandosOferta, columns: COLUNAS, loading: loading, paginationMode: 'client', onPaginationModelChange: function () { }, initialState: {
                                        sorting: {
                                            sortModel: [{ field: 'id', sort: 'asc' }],
                                        },
                                    } }) })), _jsx(BoxBotoes, __assign({ sx: { marginTop: 10 } }, { children: _jsx(BotaoFechar, { modo: modo, pagina: ROUTES.ATENDIMENTOS }) }))] }), _jsxs(Dialog, __assign({ open: PopupAgendamentoAberto, onClose: handleClose, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Agendamento" }), _jsx(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: _jsxs(Box, __assign({ display: 'flex', flexDirection: 'column', gap: 1 }, { children: [_jsx(InputDados, { id: 'data', label: 'Data', mask: '99/99/9999', value: Data, onChange: function (e) { return setData(e.target.value); }, variant: 'outlined', size: 'small', required: true }), _jsx(InputDados, { id: 'observacao', label: 'Observa\u00E7\u00E3o', value: Observacao, onChange: function (e) { return setObservacao(e.target.value); }, variant: 'outlined', size: 'small', multiline: true, rows: 3 }), _jsxs(InputDados, __assign({ select: true, id: 'agendamento_exame_adimissional', label: 'Agendar exame admissional', value: AgendamentoExameAdimissional, onChange: function (e) { return setAgendamentoExameAdimissional(!!e.target.value); }, variant: 'outlined', size: 'small', required: true }, { children: [_jsx(MenuItem, __assign({ value: 'true' }, { children: "Sim" })), _jsx(MenuItem, __assign({ value: 'false' }, { children: "N\u00E3o" }))] })), _jsx("input", { accept: 'application/pdf', style: { display: 'none' }, id: 'arquivo-upload', type: 'file', onChange: handleFileChange, value: '' }), _jsx("label", __assign({ htmlFor: 'arquivo-upload', style: { marginTop: 10 } }, { children: _jsxs(BotaoAuxiliar, __assign({ component: 'label', backgroundColor: 'terceary.main' }, { children: ["Selecionar Arquivo", _jsx("input", { type: 'file', accept: 'application/pdf', hidden: true, onChange: handleFileChange, value: '' })] })) })), AgendamentoNomeArquivoOriginal && (_jsx(InputDados, { id: 'nome_arquivo_original', variant: 'standard', value: AgendamentoNomeArquivoOriginal, disabled: true }))] })) })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Voltar" })), _jsx(Button, __assign({ onClick: salvarAgendamento, variant: 'contained', color: 'primary' }, { children: "Salvar" }))] }))] })), _jsxs(Dialog, __assign({ open: PopupEncaminhamentoAberto, onClose: handleClose, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Encaminhamento" }), _jsx(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: _jsxs(Box, __assign({ display: 'flex', flexDirection: 'column', gap: 1 }, { children: [_jsx(InputDados, { id: 'data', label: 'Data', mask: '99/99/9999', value: Data, onChange: function (e) { return setData(e.target.value); }, variant: 'outlined', size: 'small', required: true }), _jsx(InputDados, { id: 'observacao', label: 'Observa\u00E7\u00E3o', value: Observacao, onChange: function (e) { return setObservacao(e.target.value); }, variant: 'outlined', size: 'small', multiline: true, rows: 3 })] })) })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Voltar" })), _jsx(Button, __assign({ onClick: salvarEncaminhamento, variant: 'contained', color: 'primary' }, { children: "Salvar" }))] }))] })), _jsxs(Dialog, __assign({ open: PopupDesistenciaAberto, onClose: handleClose, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Desist\u00EAncia" }), _jsx(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: _jsxs(Box, __assign({ display: 'flex', flexDirection: 'column', gap: 1 }, { children: [_jsx(InputDados, { id: 'data', label: 'Data', mask: '99/99/9999', value: Data, onChange: function (e) { return setData(e.target.value); }, variant: 'outlined', size: 'small', required: true }), _jsx(InputDados, { id: 'observacao', label: 'Observa\u00E7\u00E3o', value: Observacao, onChange: function (e) { return setObservacao(e.target.value); }, variant: 'outlined', size: 'small', multiline: true, rows: 3 })] })) })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Voltar" })), _jsx(Button, __assign({ onClick: salvarDesistencia, variant: 'contained', color: 'primary' }, { children: "Salvar" }))] }))] })), _jsxs(Dialog, __assign({ open: PopupFinalizacaoAberto, onClose: handleClose, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Finalizar" }), _jsx(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: _jsxs(Box, __assign({ display: 'flex', flexDirection: 'column', gap: 1 }, { children: [_jsx(InputDados, { id: 'data', label: 'Data', mask: '99/99/9999', value: Data, onChange: function (e) { return setData(e.target.value); }, variant: 'outlined', size: 'small', required: true }), _jsx(InputDados, { id: 'observacao', label: 'Observa\u00E7\u00E3o', value: Observacao, onChange: function (e) { return setObservacao(e.target.value); }, variant: 'outlined', size: 'small', multiline: true, rows: 3 })] })) })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Voltar" })), _jsx(Button, __assign({ onClick: salvarFinalizarAtendimento, variant: 'contained', color: 'primary' }, { children: "Salvar" }))] }))] })), _jsxs(Dialog, __assign({ open: ErroEmissaoTermoAberto, onClose: function () { return setErroEmissaoTermoAberto(false); }, maxWidth: 'xs', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "N\u00E3o foi poss\u00EDvel emitir o termo" }), _jsx(DialogContent, { children: _jsx(Typography, { children: "No momento n\u00E3o foi poss\u00EDvel gerar o documento. Tente novamente mais tarde." }) }), _jsx(DialogActions, { children: _jsx(Button, __assign({ onClick: function () { return setErroEmissaoTermoAberto(false); } }, { children: "Fechar" })) })] })), loading && _jsx(Loading, {})] })) })) })));
};
export default AtendimentosEditar;
